// extracted by mini-css-extract-plugin
module.exports = {"modalCardTitle":"LicenseSeatsConflictModal_modalCardTitle_1T5zj","link":"LicenseSeatsConflictModal_link_-wZQQ"};